import { createStyles, makeStyles } from '@mui/styles';
import { MENU_BAR_HEADER_HEIGHT } from '../core/MenuBar/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    head: {
      width: '100%',
      boxSizing: 'border-box',
      height: '56px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
      zIndex: 1,
      paddingLeft: '20px',
      paddingRight: '20px',
      gap: '16px',
      '@media (max-width: 768px)': {
        paddingLeft: '10px',
        paddingRight: '10px',
        gap: '8px',
      },
    },

    leftSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      flex: 1,
      minWidth: 0,
      height: '100%',
      '@media (max-width: 768px)': {
        gap: '8px',
        '& [data-qa="documentation_create_button"]': {
          left: 0,
          margin: 0,
          alignSelf: 'center',
        },
      },
    },

    rightSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      height: '100%',
      '@media (max-width: 768px)': {
        gap: '8px',
        justifyContent: 'center',
      },
    },

    content: {
      display: 'flex',
      overflowY: 'hidden',
      height: `calc(100vh - ${MENU_BAR_HEADER_HEIGHT}px - 56px)`,
    },
    relativeWrapper: {
      position: 'relative',
      width: '100%',
      overflowY: 'hidden',
      overflowX: 'hidden',
      display: 'flex',
      flex: 1,
    },
    absoluteWrapper: {
      width: '100%',
      position: 'absolute',
      height: '100%',
      display: 'flex',
      flex: 1,
    },
  })
);
